export default "__VITE_ASSET__ce757451__"